import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import PlatformConnectionCard from './PlatformConnectionCard';
import { useFetchOAuthStatusQuery } from '../../slices/oauthSlice';

const PLATFORM_DISPLAY_NAMES: Record<string, string> = {
  'google-ads': 'Google Ads',
  'microsoft-ads': 'Microsoft Ads',
};

const PlatformConnections: React.FC = () => {
  const { data, isLoading } = useFetchOAuthStatusQuery();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" mb={2}>
        Platform Connections
      </Typography>
      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
        {data?.platforms.map((platformStatus) => (
          <PlatformConnectionCard
            key={platformStatus.platform}
            platformStatus={platformStatus}
            displayName={
              PLATFORM_DISPLAY_NAMES[platformStatus.platform] ||
              platformStatus.platform
            }
          />
        ))}
      </Stack>
    </Box>
  );
};

export default PlatformConnections;
